import { useParams } from 'react-router';
import { LegacyCard, Page } from '@shopify/polaris';
import { useContext, useRef } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import ListCustomers from '../../UI/Customers/ListCustomers';
import { postCustomer } from '../../../services/customersService';
import { NewCustomerModal } from '../../UI/Customers/NewCustomerModal';
import { checkPermission } from '../../../services/permissionsService';

const Customers = (props) => {
  const { page } = useParams();
  const [, dispatchToast] = useContext(ToastContext);
  const listCustomers = useRef();

  const createNewCustomer = (form) => {
    return postCustomer(form)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        listCustomers.current.last({ new: true });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        throw new Error(e.response.data);
      });
  };

  return <>
    <Page
      title="Clientes"
      primaryAction={
        checkPermission('CUSTOMER:CREATE') && <NewCustomerModal onAddCustomer={(e) => createNewCustomer(e)} />
      }
      divider
    >
      <LegacyCard>
        <ListCustomers ref={listCustomers} page={page || 1} />
      </LegacyCard>
    </Page>
  </>;
};

export default Customers;
